import { render } from "./NewsSlider.vue?vue&type=template&id=13f1b66f&scoped=true"
import script from "./NewsSlider.vue?vue&type=script&lang=js"
export * from "./NewsSlider.vue?vue&type=script&lang=js"

import "./NewsSlider.vue?vue&type=style&index=0&id=13f1b66f&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f1b66f"]])

export default __exports__